import { type FC } from 'react';

import { ConsentText, LEGAL_DOCS } from '@entities/legal';
import { LegalDocument } from '@shared/ui/LegalDocument';

const ConsentPage: FC = () => (
  <LegalDocument title={LEGAL_DOCS.consent.title}>
    <ConsentText />
  </LegalDocument>
);

export default ConsentPage;
